import { render, staticRenderFns } from "./Svg1.vue?vue&type=template&id=40dc2793"
import script from "./Svg1.vue?vue&type=script&lang=js"
export * from "./Svg1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports